import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

export function isInstrumentedService(entity: {
  kind: string;
  metadata: { annotations?: Record<string, string> };
}): boolean {
  if (entity.kind.toLocaleLowerCase('en-US') !== 'component') {
    return false;
  }
  const annotations = entity.metadata.annotations ?? {};
  return Boolean(
    annotations['apna.co/onboarding'] ||
      annotations['grafana/metrics-selector'] ||
      annotations['grafana/alert-label-selector'] ||
      annotations['backstage.io/kubernetes-namespace'],
  );
}

const instrumentationContent = EntityContentBlueprint.make({
  name: 'service-instrumentation',
  params: {
    path: '/health',
    title: 'Health',
    // Own top-level entity tab — not grouped under Observability/Grafana.
    filter: isInstrumentedService,
    loader: () =>
      import('./InstrumentationContent').then(m => (
        <m.InstrumentationContent />
      )),
  },
});

export const serviceInstrumentationModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [instrumentationContent],
});
